export default "__VITE_ASSET__DKVHVPLA__"